import { observer } from "mobx-react-lite";
import React from "react";
import { Project } from "../../../../../js/parsegenerated";
import { SubProjectItem } from "./SubProjectItem";

type Props = { projects: Project[]; style?: React.CSSProperties };

export const ProjectList = observer((props: Props) => {
  if (props.projects.length <= 0) return <></>;

  return (
    <>
      {props.projects.map((project) => (
        <SubProjectItem
          key={project.id}
          project={project}
          style={props.style}
        />
      ))}
    </>
  );
});
